import { CaseMaster } from "../models/tr-cr-lookup/case-master";
import { createSlice } from "@reduxjs/toolkit";
import { CasePaymentsResult } from "../models/tr-cr-lookup/case-payments";
import { CaseQueryResult } from "../models/case-query-result";
import { CivilMaster } from "../models/civil-lookup/civil-master";
import { ConfigOption } from "../models/config";


interface GlobalState {
  menuCollapsed: boolean;
  activeCaseNumber: string;
  caseMaster: CaseMaster;
  casePayment: CasePaymentsResult;
  queryResult: CaseQueryResult;
  civilMaster: CivilMaster;
  config: ConfigOption[];
  activeTransactionId: string;

}

const initialState: GlobalState = {
  menuCollapsed: false,
  activeCaseNumber: null,
  caseMaster: null,
  casePayment: null,
  queryResult: null,
  civilMaster: null,
  config: null,
  activeTransactionId: null
};

const globalStore = createSlice({
  name: "global",
  initialState,
  reducers: {
    getMenuCollapsed: (state) => {
      state.menuCollapsed;
    },
    setMenuCollapsed: (state) => {
      state.menuCollapsed = !state.menuCollapsed;
    },
    getActiveCaseNumber: (state) => {
      state.activeCaseNumber;
    },
    setActiveCaseNumber: (state, action) => {
      state.activeCaseNumber = action.payload;
    },
    getCaseMaster: (state) => {
      state.caseMaster;
    },
    updateCaseMaster: (state, action) => {
      state.caseMaster = {
        ...state.caseMaster,
        ...action.payload
      };
    },
    resetCaseMaster: (state) => {
      state.caseMaster = null;
    },
    getCasePayment: (state) => {
      state.casePayment;
    },
    updateCasePayment: (state, action) => {
      state.casePayment = {
        ...state.casePayment,
        ...action.payload
      };
    },
    resetCasePayment: (state) => {
      state.casePayment = null;
    },
    getQueryResult: (state) => {
      state.queryResult;
    },
    setQueryResult: (state, action) => {
      state.queryResult = { ...state.queryResult, ...action.payload };
    },
    getCivilMaster: (state) => {
      state.civilMaster;
    },
    setCivilMaster: (state, action) => {
      state.civilMaster = {
        ...state.civilMaster,
        ...action.payload
      };
    },
    resetCivilMaster: (state) => {
      state.civilMaster = null;
    },
    setConfig: (state, action) => {
      state.config = action.payload;
    },
    setActiveTransactionId: (state, action) => {
      state.activeTransactionId = action.payload;
    },
    getActiveTransactionId: (state) => {
      state.activeTransactionId;
    },
  }
});

export const {
  getMenuCollapsed,
  setMenuCollapsed,
  getActiveCaseNumber: getActiveCaseId,
  setActiveCaseNumber,
  getCaseMaster,
  updateCaseMaster,
  resetCaseMaster,
  updateCasePayment,
  resetCasePayment,
  getCasePayment,
  getQueryResult,
  setQueryResult,
  setCivilMaster,
  getCivilMaster,
  resetCivilMaster,
  setConfig,
  setActiveTransactionId,
  getActiveTransactionId
} = globalStore.actions;

export default globalStore.reducer;
